import { EntityMetadata } from "@ngrx/data";
import { ListingPermission } from "../interfaces/listing-permission";

export const listingPermissionMetadata: Partial<EntityMetadata<ListingPermission>> = {
	selectId: (listingPermission: ListingPermission) =>
		listingPermission.listingSK + ":" + listingPermission.permission,
};
